import { IApplicationState } from '../../types/redux';

export function getIsMapServicesEnabled(state: IApplicationState) {
  return state.common.mapOptions?.servicesEnabled || false;
}
